import React, { Component, useMemo } from "react";
import {
  Table,
  Space,
  Modal,
  Input,
  Button,
  Form,
  Checkbox,
  Row,
  Col,
} from "antd";
import {
  FaPencilAlt,
  FaBan,
  FaCheckCircle,
  FaRegTrashAlt,
} from "react-icons/fa";
import { MdAddCircle } from "react-icons/md";
import _, { constant } from "lodash";
import {
  ExclamationCircleOutlined,
  FileAddOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { withRouter } from "react-router";
import DisplayControl from "./DisplayControl";
import Loadingsvg from "./common/Loadingsvg";
import utils from "../common/utils";
import consts, { TIME_OF_DEBOUNCE } from "../consts";

const PERMISSION_LINK_SCREEN_ADD_ADMIN = "/admin/create";
const PERMISSION_LINK_SCREEN_ADD_ROLE_TO_ADMIN =
  "/authorization/role-users/multi";
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 16,
    span: 8,
  },
};

const { confirm } = Modal;
const { Search } = Input;
class AdminManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleModalAdmin: false,
      isAddNew: false,
      pubkey: "",
      name: "",
      visibleModalRoleDetail: false,
      roleOfUser: [],
      visibleModalRoleOfUser: false,
      addRoleToUserBody: {
        pubkey: "",
        roles: [],
      },
      isLoadingAddModal: false,
      dataSourceRoleDetail: [],
      search: false,
    };
  }

  columnsAdmin = [
    {
      align: "center",
      title: "Mã",
      dataIndex: "id",
      key: "id",
    },
    {
      align: "center",
      title: "Pubkey",
      dataIndex: "pubkey",
      key: "pubkey",
    },
    {
      align: "center",
      title: "Tên hiển thị",
      dataIndex: "display_name",
      key: "display_name",
    },
    // {
    //   align: "center",
    //   title: "Vai trò",
    //   dataIndex: "display_name",
    //   key: "display_name",
    // },
    {
      align: "center",
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      render: () => <div>Đang hoạt động</div>,
    },
    {
      align: "center",
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      render: (action, record) => (
        <Space size="middle">
          {/*<FaPencilAlt className="styled-icon" />*/}
          {record.is_banned ? (
            <FaBan
              className="styled-icon"
              title="Bỏ cấm người dùng"
              onClick={() => this.showModalUnBan(record)}
            />
          ) : (
            <FaCheckCircle
              className="styled-icon"
              title="Cấm người dùng"
              onClick={() => this.showModalBan(record)}
            />
          )}
          <BookOutlined
            title="Thông tin người dùng"
            className="styled-icon"
            onClick={() => {
              this.props.history.push(
                `/admin/limit-transfer-money/${record.pubkey}`
              );
            }}
          />
          <DisplayControl
            permission_link_screen={
              consts.AUTH.AUTHORIZATION__ROLE_USERS__pUBKEY
            }
            action={consts.CONTROLS.GET}
          >
            <FileAddOutlined
              title="Chi tiết vai trò"
              className="styled-icon"
              onClick={() => this.showModalRoleOfUser(record)}
            />
          </DisplayControl>
          <FaRegTrashAlt
            className="styled-icon"
            title="Xóa người dùng"
            onClick={() => this.showModalDele(record)}
          />
        </Space>
      ),
    },
  ];

  columnsRoleDetail = [
    {
      title: "Quyền",
      dataIndex: "name",
      key: "id",
    },
  ];

  componentDidMount() {
    const { fetchAdmins, getRoles, getAction } = this.props;
    fetchAdmins();
    getRoles();
    getAction(this.handleColumnModalDetail);
  }

  handleColumnModalDetail = (actions) => {
    _.forEach(actions, ({ action: title, id }) => {
      this.columnsRoleDetail.push({
        title,
        key: `action_id:${id}`,
        render: (record) => {
          let isChecked = false;
          if (
            !_.isEmpty(record.controls) &&
            _.some(record.controls, (ctl) => ctl.id === id)
          ) {
            isChecked = true;
          }

          return (
            <div>
              <Checkbox
                onChange={(e) => e.preventDefault()}
                checked={isChecked}
              />
            </div>
          );
        },
      });
    });
  };

  showModalBan = (record) => {
    confirm({
      title: "Bạn có chắc chắn muốn cấm người dùng này không ?",
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: "Cấm",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        this.props.banAdmin({ pubkey: record.pubkey }, () => {
          this.props.fetchAdmins();
        });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  showModalUnBan = (record) => {
    confirm({
      title: "Bạn có chắc chắn muốn bỏ cấm người dùng này không ?",
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: "Bỏ Cấm",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        this.props.unBanAdmin({ pubkey: record.pubkey }, () => {
          this.props.fetchAdmins();
        });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  showModalDele = (record) => {
    confirm({
      title: "Bạn có chắc chắn muốn xóa người dùng này không ?",
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: "Xóa",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        this.props.delAdmin({ id: record.id }, () => {
          this.props.fetchAdmins();
        });
        // this.props.delAdmin({  pubkey: record.pubkey }, () => this.props.fetchAdmins());
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  showModalRoleOfUser = (record) => {
    this.props.getRoleByPubkey(record.pubkey, this.handleGetRolesOfUserSucceed);
  };

  showModalDetail = () => {
    this.setState({
      visibleModalAdmin: true,
      isAddNew: false,
    });
  };

  showModalAdd = () => {
    this.setState({
      visibleModalAdmin: true,
      isAddNew: true,
    });
  };

  handleCancelModalAdmin = () => {
    this.setState({
      visibleModalAdmin: false,
    });
  };

  toggleModalRoleInfo = (permissions) => {
    this.setState({
      visibleModalRoleDetail: !this.state.visibleModalRoleDetail,
      dataSourceRoleDetail: Object.values(permissions || {}) || [],
    });
  };

  showModalRoleDetail = (roleId) => {
    this.props.getRoleInfoById(roleId, this.toggleModalRoleInfo);
  };

  handleCancelModalRoleOfUser = () => {
    this.setState({
      visibleModalRoleOfUser: false,
      addRoleToUserBody: {
        pubkey: "",
        roles: [],
      },
      isLoadingAddModal: false,
    });
  };

  handleGetRolesOfUserSucceed = (user, roles) => {
    console.log(user, roles);
    this.setState({
      visibleModalRoleOfUser: true,
      roleOfUser: roles,
      addRoleToUserBody: {
        ...this.state.addRoleToUserBody,
        pubkey: user.pubkey,
      },
    });
  };

  handleChangeCheckboxParent = (roleId, active) => {
    let tempState = this.state.addRoleToUserBody;
    if (active) {
      if (
        this.state.roleOfUser?.find((e) => e.role_id === roleId && e.active)
      ) {
        tempState.roles = tempState.roles.filter((e) => e.role_id !== roleId);
      } else {
        tempState.roles.push({ role_id: roleId, active });
      }
    } else {
      const role = this.state.roleOfUser?.find((e) => e.role_id === roleId);
      if (role) {
        if (role.active) {
          tempState.roles.push({ role_id: roleId, active });
        } else {
          tempState.roles = tempState.roles.filter((e) => e.role_id !== roleId);
        }
      }
    }
    this.setState({
      addRoleToUserBody: tempState,
    });
  };

  handleSubmitModalAddRoleToAdmin = (event) => {
    event.preventDefault();
    if (
      this.state.addRoleToUserBody.pubkey !== "" &&
      this.state.addRoleToUserBody.roles.length > 0
    ) {
      this.setState({
        isLoadingAddModal: true,
      });
      this.props.postRoleForUser(
        this.state.addRoleToUserBody,
        this.handleCancelModalRoleOfUser
      );
    } else {
      this.handleCancelModalRoleOfUser();
      utils.showNotification("Lỗi", "Thông tin chưa thay đổi", "error");
    }
  };

  onChangeName = ({ target: { value: name } }) => this.setState({ name });
  onChangePubkey = ({ target: { value: pubkey } }) => this.setState({ pubkey });

  handleCancel = () => {
    this.setState({
      isLoadingAddModal: false,
      visibleModalAdmin: false,
    });
  };

  onSubmit = () => {
    let isExist = _.some(this.props.listAdmins, (admin) => (admin || {}).pubkey === this.state.pubkey)
    if (!isExist) {
      if (_.isEmpty(this.state.name)) {
        utils.showNotification("Error!", "Nhập đầy đủ thông tin!", "error");
      } else {
        this.setState({
          isLoadingAddModal: true,
        });
        this.props.onCreateAdmin({
          display_name: this.state.name,
          pubkey: this.state.pubkey,
        }, () => {
          this.handleCancel();
        });
      }
    } else {
      utils.showNotification("Error!", "Tài khoản đã tồn tại!", "error");
    }
  };

  onSearch = (value) => {
    if (value) {
      this.setState({ search: true });
      this.props.fetchAdminInfo(value);
    } else {
      this.setState({ search: false });
    }
  };

  render() {
    const {
      isAddNew,
      visibleModalAdmin,
      visibleModalRoleDetail,
      visibleModalRoleOfUser,
      search,
    } = this.state;

    return (
      <div className="admin-management">
        <div className="feature-add">
          <h3> Danh sách quản trị viên </h3>
          <div className="d-flex">
            <Search
              style={{ width: 500 }}
              placeholder="Nhập Pubkey"
              onSearch={this.onSearch}
              allowClear
              enterButton
            />
            <DisplayControl
              permission_link_screen={consts.AUTH.MANAGER__CREATE}
              action="POST"
            >
              <Button
                className="d-flex align-items ml-medium"
                onClick={this.showModalAdd}
              >
                <MdAddCircle size="20" className="styled-icon" />
                Thêm quản trị viên
              </Button>
            </DisplayControl>
          </div>
        </div>
        <Table
          dataSource={
            search ? [...[this.props.adminInfo]] : this.props.listAdmins || []
          }
          columns={this.columnsAdmin}
          bordered
        />
        {/* Modal Add and Detail */}
        <Modal
          // className="modal-add-admin"
          title={
            isAddNew ? "Thêm quản trị viên" : "Sửa thông tin quản trị viên"
          }
          visible={visibleModalAdmin}
          footer={[
            <Button onClick={this.handleCancel} style={{ width: "64px" }}>
              Hủy
            </Button>,
            <Button
              // className="btn-elm-2"
              type="primary"
              style={{ marginLeft: 12, width: "64px" }}
              onClick={this.onSubmit}
              icon={
                <Loadingsvg
                  name="bars"
                  hidden={!this.state.isLoadingAddModal}
                  size={25}
                />
              }
            >
              {!this.state.isLoadingAddModal ? (isAddNew ? "Thêm" : "Lưu") : ""}
            </Button>,
          ]}
          onOk={this.onSubmit}
          onCancel={this.handleCancelModalAdmin}
        >
          <Form {...layout}>
            <Form.Item label="Tên hiển thị">
              <Input onChange={this.onChangeName} />
            </Form.Item>
            <Form.Item label="Pubkey">
              <Input onChange={this.onChangePubkey} />
            </Form.Item>
            {/* <Form.Item {...tailLayout} style={{ marginBottom: "12px" }}>
              <Button
                // className="btn-elm"
                type="primary"
                onClick={this.handleCancel}
                style={{ width: "64px" }}
              >
                Hủy
              </Button>
              <Button
                // className="btn-elm-2"
                type="primary"
                style={{ marginLeft: 12, width: "64px" }}
                onClick={this.onSubmit}
                icon={<Loadingsvg name='bars'
                  hidden={!this.state.isLoadingAddModal} size={25} />}
              >
                {!this.state.isLoadingAddModal ? (isAddNew ? "Thêm" : "Lưu") : ""}
              </Button>
            </Form.Item> */}
          </Form>
        </Modal>

        {/* Modal to repair roles   */}
        <Modal
          // className="modal-repair-admin"
          title={"Chi tiết vai trò"}
          visible={visibleModalRoleOfUser}
          onCancel={this.handleCancelModalRoleOfUser}
          width={"400px"}
          footer={null}
        >
          <div className="loading-modal-repair-role" />
          {this.props.listRoles.map((role, index) => {
            return (
              <MyCheckbox
                key={index}
                role={role}
                visibleModalRole={this.state.visibleModalRoleOfUser}
                roleOfUser={this.state.roleOfUser}
                showModalRoleDetail={this.showModalRoleDetail}
                handleChangeCheckboxParent={this.handleChangeCheckboxParent}
              />
            );
          })}
          <Row style={{ marginTop: "10px" }} justify="end">
            <Col span={4}>
              <Button type="primary" onClick={this.handleCancelModalRoleOfUser}>
                Hủy
              </Button>
            </Col>
            <Col>
              <DisplayControl
                permission_link_screen={
                  consts.AUTH.AUTHORIZATION__ROLE_USERS_MULTI
                }
                action={consts.CONTROLS.POST}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    marginLeft: 12,
                    width: "80px",
                  }}
                  icon={
                    <Loadingsvg
                      name="bars"
                      hidden={!this.state.isLoadingAddModal}
                      size={25}
                    />
                  }
                  onClick={this.handleSubmitModalAddRoleToAdmin}
                >
                  {this.state.isLoadingAddModal === false ? "Xác nhận" : ""}
                </Button>
              </DisplayControl>
            </Col>
          </Row>
        </Modal>
        {/* Modal detail */}
        <Modal
          // className="modal-detail-admin"
          visible={visibleModalRoleDetail}
          footer={null}
          onCancel={() => this.toggleModalRoleInfo([])}
          width="650px"
        >
          <div className="permissionTable">
            <div style={{ fontSize: "20px" }}>Quyền được sử dụng</div>
            <Table
              dataSource={this.state.dataSourceRoleDetail || []}
              columns={this.columnsRoleDetail}
              bordered
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(AdminManagement);

// component role checkbox
class MyCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
    };
  }
  handleChangeCheckbox = (event) => {
    event.preventDefault();
    const { handleChangeCheckboxParent, role } = this.props;
    const checked = event.target.checked;
    this.setState(
      {
        isChecked: checked,
      },
      () => {
        handleChangeCheckboxParent(role.id, checked);
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // handle new visibleDetail
    if (nextProps.visibleModalRole !== this.props.visibleModalRole) {
      if (
        nextProps.visibleModalRole &&
        _.some(
          nextProps.roleOfUser,
          (e) => e.role_id === nextProps.role.id && e.active
        )
      ) {
        this.setState({
          isChecked: true,
        });
      } else {
        this.setState({
          isChecked: false,
        });
      }
    }
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   // handle new visibleDetail
  //   if (nextProps.visibleModalRole !== this.props.visibleModalRole) {
  //     if (nextProps.visibleModalRole &&  _.some(nextProps.roleOfUser,{'active':true,'role_id':nextProps.role.id})) {
  //       this.setState({
  //         isChecked: true,
  //       });
  //     } else {
  //       this.setState({
  //         isChecked: false,
  //       });
  //     }
  //   }
  // }

  componentDidMount() {
    const { role, roleOfUser } = this.props;
    if (_.some(roleOfUser, (e) => e.role_id === role.id && e.active)) {
      this.setState({
        isChecked: true,
      });
    } else {
      this.setState({
        isChecked: false,
      });
    }
  }

  showModalRoleDetail = () => {
    const { showModalRoleDetail, role } = this.props;
    showModalRoleDetail(role.id);
  };

  render() {
    const { role, disabled } = this.props;
    return (
      <div style={{ display: "flex", marginBottom: "20px" }}>
        <Checkbox
          disabled={disabled}
          style={{ flex: 1.5 }}
          checked={this.state.isChecked}
          onChange={this.handleChangeCheckbox}
        >
          {role.role}
        </Checkbox>
        <div style={{ flex: 1 }} />
        <DisplayControl
          permission_link_screen={consts.AUTH.AUTHORIZATION__ROLES__rOLEID}
          action={consts.CONTROLS.GET}
        >
          <Button
            // className="btn"
            onClick={this.showModalRoleDetail}
            type="primary"
            style={{ flex: 0.5 }}
          >
            Chi tiết
          </Button>
        </DisplayControl>
      </div>
    );
  }
}
